
let language = {
    
    PAYMENT_CANCEL_PAY_FAIL_TITLE: "付款失败！",
    PAYMENT_CANCEL_PAY_FAIL_TIP: "很遗憾地通知您，您的订单未付款成功",
    
    PAYMENT_CANCEL_BACK_ORDER_BTN: "返回我的订单",
    PAYMENT_CANCEL_CONTINUE_SHOPPING_BTN: "继续购物",
};

export { language }